import React, { useState } from "react";
import { billingV2Styles } from "./BillingV2Style";
import ContentTabs from "./ContentTabs";
import { BILLING_V2_TABS } from "../../constants/CoreConstants";
import Subscription from "./subscription/Subscription";
import UsageHistory from "../Billing/BottomPart/UsageHistory";
import InvoiceHistory from "../Billing/BottomPart/InvoiceHistory";

const ContentSection = () => {
  const [activeTab, setActiveTab] = useState(BILLING_V2_TABS.SUBSCRIPTION);
  const classes = billingV2Styles();

  const handleTabChange = (_event, value) => {
    setActiveTab(value);
  };

  const renderContent = () => {
    switch (activeTab) {
      case BILLING_V2_TABS.SUBSCRIPTION:
        return <Subscription setActiveTab={setActiveTab} />;
      case BILLING_V2_TABS.PAYMENTS:
        return <UsageHistory />;
      case BILLING_V2_TABS.INVOICES:
        return <InvoiceHistory />;
      default:
        return null;
    }
  };

  return (
    <div className={classes.contentWrapper}>
      <ContentTabs activeTab={activeTab} handleTabChange={handleTabChange} />
      
      {renderContent()}
    </div>
  );
};

export default ContentSection;
